"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return useColorbar;
    }
});
const _react = require("react");
const _colormap = require("../utilities/colormap.js");
const initialPaletteData = {
    data: [],
    width: 15,
    height: 480,
    colorSpace: "srgb"
};
function useColorbar(initialData) {
    const [paletteData, setPaletteData] = (0, _react.useState)(initialData || initialPaletteData);
    const colorbar = (0, _react.useMemo)(()=>{
        return (0, _colormap.colormap)(paletteData);
    }, [
        paletteData
    ]);
    return [
        colorbar,
        setPaletteData
    ];
}
